<template>
  <div>
    <el-dialog title="History" :visible.sync="visible" width="675px" :center="false">
      <div slot="title" class="title-container"><span>Operate History</span></div>
      <el-table
        :data="data"
        :row-style="{height:'40px'}"
        stripe
        border
        size="small"
        :header-cell-style="{background:'#D7D7D7',color:'#000', padding:'4px'}"
      >
        <el-table-column width="200" property="date" label="Date & Time"></el-table-column>
        <el-table-column width="150" property="operator" label="Operator"></el-table-column>
        <el-table-column  width="300" property="action" label="Action"></el-table-column>
        <div slot="empty"><span class="popover-table-empty-text">No Data</span></div>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogOperationHistory',
  computed: {
    visible: {
      get () {
        return this.dialogVisible
      },
      set (val) {
        this.$emit('closed')
      }

    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
